// src/App.js
import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Layout from './components/Layout';
import Home     from './pages/Home';
import Screener from './pages/Screener';
import Charts   from './pages/Charts';
import Settings from './pages/Settings';
import Watchlist from './pages/Watchlist';
import Orders   from './pages/Orders';
import Margins  from './pages/Margins';
import PortfolioAnalysis from './pages/PortfolioAnalysis';
import StockList    from './pages/StockList';
import DailyData    from './pages/DailyData';
import LiveQuotes   from './pages/LiveQuotes';
import ExpenseTracker from './pages/ExpenseTracker';
import Login          from './pages/Login';
import Register        from './pages/Register';
import ForgotPassword  from './pages/ForgotPassword';
import ResetPassword   from './pages/ResetPassword';

// Wraps all authenticated pages in the sidebar layout.
// Redirects to /login if the user is not authenticated.
function AuthenticatedApp() {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return (
    <Layout>
      <Routes>
        <Route path="/"          element={<Home />}     />
        <Route path="/watchlist" element={<Watchlist />} />
        <Route path="/screener"  element={<Screener />}  />
        <Route path="/orders"    element={<Orders />}    />
        <Route path="/charts"    element={<Charts />}    />
        <Route path="/margins"   element={<Margins />}   />
        <Route path="/analysis"  element={<PortfolioAnalysis />} />
        <Route path="/stocks"    element={<StockList />}  />
        <Route path="/daily"     element={<DailyData />}  />
        <Route path="/quotes"    element={<LiveQuotes />} />
        <Route path="/expense-tracker" element={<ExpenseTracker />} />
        <Route path="/settings"  element={<Settings />}  />
        <Route path="*"          element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login"           element={<Login />}           />
      <Route path="/register"        element={<Register />}        />
      <Route path="/forgot-password" element={<ForgotPassword />}  />
      <Route path="/reset-password"  element={<ResetPassword />}   />
      <Route path="/*"               element={<AuthenticatedApp />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
}
